import { Link } from 'react-router-dom';
import { LanguageSwitcher } from './LanguageSwitcher';
import { useI18n } from '../i18n/useI18n';

export function Header() {
  const { t } = useI18n();

  return (
    <header className="site-header">
      <Link className="brand" to="/" aria-label="DDProof Camera">
        <img src="/assets/ddproof-app-icon.png" alt="" />
        <span>DDProof</span>
      </Link>
      <nav className="main-nav" aria-label={t('nav.label')}>
        <a href="/#how-it-works">{t('nav.how')}</a>
        <a href="/#use-cases">{t('nav.cases')}</a>
        <a href="/#trust-layers">{t('nav.trust')}</a>
        <Link to="/privacy">{t('nav.privacy')}</Link>
        <a href="/#faq">{t('nav.faq')}</a>
        <Link className="nav-download" to="/download">
          {t('nav.download')}
        </Link>
      </nav>
      <LanguageSwitcher />
    </header>
  );
}
